import { render, staticRenderFns } from "./CultivarsForm.vue?vue&type=template&id=6aaea810&"
import script from "./CultivarsForm.vue?vue&type=script&lang=js&"
export * from "./CultivarsForm.vue?vue&type=script&lang=js&"
import style0 from "./CultivarsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports